import React, { useState } from 'react';
import { Form, Input, Button, Divider, Select, Tabs, message, Typography } from 'antd';
import { SyncOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { useStudentInfoAction } from '_actions';
import { UploadForm } from '_components/dbportal/UploadForm';
import { useClassWrapper } from '_helpers';
import { useFetchWrapper } from '_helpers';

export { AddStudentForm }

const { TabPane } = Tabs;
const { Option } = Select;
const { Text } = Typography;

var upload_form = [
    { title: 'Mã học sinh',  dataIndex: 'student_id',  key: 'student_id'  },
    { title: 'Tên học sinh', dataIndex: 'name',        key: 'name'        },
    { title: 'Tên buổi học', dataIndex: 'lesson_name', key: 'lesson_name' },
    { title: 'Ngày',         dataIndex: 'date',        key: 'date'        },
    { title: 'Lỗi',          dataIndex: 'error',       key: 'error'       },
]

function AddStudentForm(props) {
    const [addForm]    = Form.useForm();
    const [createForm] = Form.useForm();
    const [creating,   setCreating]   = useState(false);
    const [idLoading,  setIdLoading]  = useState(false);
    const [generatedId, setGeneratedId] = useState('');
    const studentInfoAction = useStudentInfoAction();
    const classWrapper = useClassWrapper();
    const fetchWrapper = useFetchWrapper();

    function handleAddByStudentId() {
        addForm.validateFields().then((values) => {
            studentInfoAction.AddStudent(values.student_id);
        });
    }

    async function fetchNewId() {
        setIdLoading(true);
        try {
            const res  = await fetchWrapper.get('/api/manager/students/generate-id', null, null);
            const json = await res.json();
            if (json.status === 'Success') {
                const id = json.message.student_id;
                setGeneratedId(id);
                createForm.setFieldsValue({ student_id: id });
            }
        } catch {}
        setIdLoading(false);
    }

    async function handleTabChange(key) {
        if (key === 'create' && !generatedId) {
            await fetchNewId();
        }
    }

    async function handleCreateAccount() {
        const values = await createForm.validateFields();
        setCreating(true);
        try {
            const classId = classWrapper.curClass.class_id;
            var body = new URLSearchParams();
            body.append('name',          values.name);
            body.append('student_id',    values.student_id);
            body.append('email',         values.email         || '');
            body.append('gender',        values.gender        || '');
            body.append('phone_number',  values.phone_number  || '');
            body.append('parent_number', values.parent_number || '');
            const res = await fetchWrapper.post(
                `/api/classes/${classId}/members/create`,
                'application/x-www-form-urlencoded',
                body
            );
            const json = await res.json();
            if (json.status === 'Success') {
                message.success(`Đã tạo "${values.name}" — ID & mật khẩu: ${values.student_id}`);
                setGeneratedId('');
                createForm.resetFields();
                if (props.onSuccess) props.onSuccess();
            } else {
                message.error(json.message || 'Có lỗi xảy ra');
            }
        } catch (e) {
            message.error('Có lỗi xảy ra: ' + e.message);
        }
        setCreating(false);
    }

    return (
        <Tabs defaultActiveKey="add" onChange={handleTabChange}>
            <TabPane tab="Thêm bằng mã học sinh" key="add">
                <h6>Nhập mã học sinh</h6>
                <Form form={addForm} layout="vertical" name="add_form">
                    <i style={{ color: 'var(--ink-2)' }}>Thêm nhiều học sinh cách nhau bằng dấu ','</i><br />
                    <i style={{ color: 'var(--ink-2)' }}>Học sinh được thêm vào lớp phải có tài khoản trong hệ thống.</i><br /><br />
                    <Form.Item name="student_id" label="Mã học sinh:"
                        rules={[{ required: true, message: 'Nhập mã học sinh' }]}>
                        <Input placeholder="VD: 19020001, 19020002" />
                    </Form.Item>
                    <Form.Item label=" " colon={false}>
                        <Button type="primary" onClick={handleAddByStudentId}>Thêm học sinh</Button>
                    </Form.Item>
                </Form>
                <Divider />
                <h6>Tải file CSV tổng hợp</h6>
                <i style={{ color: 'var(--ink-2)' }}>Cột: <b>lesson_name</b>, <b>description</b>, <b>start_date</b>, <b>duration</b>, và 7 cột thứ: <b>Mon, Tue, Wed, Thu, Fri, Sat, Sun</b>.</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• Mỗi hàng có <b>lesson_name</b> (+ <b>description</b>) → một buổi trong <b>giáo án</b>, theo thứ tự.</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• <b>start_date</b> → ngày bắt đầu lớp (hàng đầu tiên).</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• <b>duration</b> → thời lượng mỗi buổi (phút, VD <b>120</b>); để trống = 90 phút.</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• Cột thứ (Mon…Sun): điền <b>giờ bắt đầu</b> (VD <b>18:00</b>) hoặc <b>khoảng giờ</b> (VD <b>18:00-19:30</b>) cho ngày có buổi; để trống = không học ngày đó.</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• Nhiều buổi trong cùng một ngày → mỗi giờ ghi ở <b>một hàng riêng</b> dưới cột thứ đó (VD Mon: hàng 1 ghi 08:00, hàng 2 ghi 14:00-15:30).</i><br />
                <i style={{ color: 'var(--ink-2)' }}>• <b>student_id</b> (tuỳ chọn) → thêm học sinh vào lớp.</i><br />
                <i style={{ color: 'var(--ink-4)' }}>Ngày các buổi tự xếp theo lịch tuần từ start_date. Định dạng ngày: YYYY-MM-DD hoặc DD/MM/YYYY.</i><br /><br />
                <UploadForm
                    columns={upload_form}
                    formurl={classWrapper.curClass ? `/api/classes/${classWrapper.curClass.class_id}/import/classinfo` : ''}
                />
                <br /><br />
            </TabPane>

            <TabPane tab="Tạo tài khoản mới" key="create">
                <i>Tạo tài khoản học sinh mới và tự động thêm vào lớp hiện tại.</i><br /><br />
                <Form form={createForm} layout="vertical" name="create_form">
                    <Form.Item name="name" label="Họ và tên"
                        rules={[{ required: true, message: 'Nhập họ tên' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="student_id"
                        label="Mã học sinh (ID đăng nhập)"
                        extra={
                            <Text type="secondary" style={{ fontSize: 12 }}>
                                <InfoCircleOutlined style={{ marginRight: 4 }} />
                                Mật khẩu mặc định sẽ giống mã học sinh này
                            </Text>
                        }
                    >
                        <Input.Group compact>
                            <Form.Item name="student_id" noStyle>
                                <Input
                                    style={{ width: 'calc(100% - 110px)', fontWeight: 600, letterSpacing: 1 }}
                                    readOnly
                                    value={generatedId}
                                />
                            </Form.Item>
                            <Button
                                icon={<SyncOutlined spin={idLoading} />}
                                onClick={fetchNewId}
                                loading={idLoading}
                                style={{ width: 110 }}
                            >
                                Tạo mã mới
                            </Button>
                        </Input.Group>
                    </Form.Item>

                    <Form.Item name="parent_number" label="Số điện thoại phụ huynh"
                        rules={[{ required: true, message: 'Nhập số điện thoại phụ huynh' }]}>
                        <Input placeholder="VD: 0912345678" />
                    </Form.Item>

                    <Form.Item name="gender" label="Giới tính">
                        <Select allowClear placeholder="Chọn giới tính">
                            <Option value="male">Nam</Option>
                            <Option value="female">Nữ</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item name="phone_number" label="Số điện thoại học sinh">
                        <Input placeholder="Tùy chọn" />
                    </Form.Item>

                    <Form.Item name="email" label="Email">
                        <Input placeholder="Tùy chọn" />
                    </Form.Item>

                    <Form.Item label=" " colon={false}>
                        <Button
                            type="primary"
                            onClick={handleCreateAccount}
                            loading={creating}
                        >
                            Tạo tài khoản & thêm vào lớp
                        </Button>
                    </Form.Item>
                </Form>
            </TabPane>
        </Tabs>
    );
}
